import React, { FC } from 'react';
import './add-post-button.sass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons/faPlusSquare';
import Button from '../../../../../../shared/components/button/button';

export interface IAddPostButtonProps {
  text: string;
  style?: { [key: string]: any };
  onClick: () => void;
  handleEnterKey?: (event: React.KeyboardEvent<Element>) => void;
}

export const AddPostButton: FC<IAddPostButtonProps> = ({ text, style, onClick, handleEnterKey }) => {
  return (
    <Button onClick={onClick} onKeyPress={handleEnterKey} style={style} className="add-post" data-testid="add-post">
      <FontAwesomeIcon icon={faPlusSquare} size={'sm'} />
      {text}
    </Button>
  );
};

export default AddPostButton;
